module.exports = __webpack_public_path__ + "h5/img/tjcg.3f8f0f23.png";